import { Drawer, DrawerContent } from "@/components/drawer";
import { formatMetric } from "@/lib/metrics";
import { useCompare } from "./queries";

export function CompareDrawer({
  modelId,
  open,
  onClose,
  a,
  b,
}: {
  modelId: string;
  open: boolean;
  onClose: () => void;
  a: number | null;
  b: number | null;
}) {
  const { data } = useCompare(modelId, a, b);
  return (
    <Drawer open={open} onOpenChange={(o) => !o && onClose()}>
      <DrawerContent title={`Compare #${a} ↔ #${b}`}>
        {data && (
          <div className="p-5">
            {(() => {
              const aM = data.a.metrics ?? {};
              const bM = data.b.metrics ?? {};
              const keys = Array.from(new Set([...Object.keys(aM), ...Object.keys(bM)]));
              if (keys.length === 0) {
                return (
                  <p className="text-xs text-fg-muted">
                    No metrics available — one or both revisions may have failed training.
                  </p>
                );
              }
              return (
                <table className="w-full text-xs">
                  <thead>
                    <tr>
                      <th className="text-left text-fg-muted pb-2">Metric</th>
                      <th className="text-left pb-2 mono">#{data.a.revision_no}</th>
                      <th className="text-left pb-2 mono">#{data.b.revision_no}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {keys.map((k) => (
                      <tr key={k} className="border-t border-border">
                        <td className="py-1.5">{k}</td>
                        <td className="py-1.5 mono tnum">
                          {typeof aM[k] === "number"
                            ? formatMetric(k, aM[k] as number)
                            : aM[k] != null
                              ? String(aM[k])
                              : "—"}
                        </td>
                        <td className="py-1.5 mono tnum">
                          {typeof bM[k] === "number"
                            ? formatMetric(k, bM[k] as number)
                            : bM[k] != null
                              ? String(bM[k])
                              : "—"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              );
            })()}
          </div>
        )}
      </DrawerContent>
    </Drawer>
  );
}
